import { useId } from "react";
import { SYMBOL_BODY, SYMBOL_FOLD, SYMBOL_FOLD_COLOR, SYMBOL_STOPS, SYMBOL_VIEWBOX } from "./brand-paths";

/**
 * Símbolo da Vixio no violeta original (docs/brand/analise-marca.md: "o violeta original continua sendo a marca").
 * Só a marca usa o violeta; o acento funcional do painel continua o petróleo dos tokens.
 */
export function VixioSymbol({ size = 20, title }: { size?: number; title?: string }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg
      className="vx-symbol"
      viewBox={SYMBOL_VIEWBOX}
      width={Math.round(size * 1.255)}
      height={size}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      focusable="false"
    >
      <defs>
        <linearGradient id={`vx-sym-${id}`} gradientUnits="userSpaceOnUse" x1="0" y1="14" x2="0" y2="1570">
          {SYMBOL_STOPS.map(([o, c]) => (
            <stop key={o} offset={o} stopColor={c} />
          ))}
        </linearGradient>
      </defs>
      <path fill={`url(#vx-sym-${id})`} fillRule="evenodd" d={SYMBOL_BODY} />
      <path fill={SYMBOL_FOLD_COLOR} d={SYMBOL_FOLD} />
    </svg>
  );
}
